import React from 'react';
import { View, Text, StyleSheet, SectionList, RefreshControl, TouchableOpacity, Image, Platform } from 'react-native';
import CS from '../../constants/Styles';
import Colors from '../../constants/Colors';
import { BackgroundGradient, SafeAreaView, Loader } from '../../components';
import UserTile from '../../components/Users/UserTile';
import * as rtApi from '../../components/Api';
import UserState from '../../src/contexts/UserState';
import { useLinkTo } from '@react-navigation/native';

const Customers = ({ navigation }) => {
  const [user, setUser] = React.useContext(UserState);

  const [customers, setCustomers] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  // const [inviteImgStyle, setInviteImgStyle] = React.useState({});

  const linkTo = useLinkTo();
  // const windowWidth = Dimensions.get('window').width;

  React.useEffect(() => {
    getCustomers();
    // setInviteImgStyle(inviteImgStyleWeb(windowWidth));
    return () => rtApi.cancel();
  }, []);

  React.useEffect(() => {
    // when parent tab button ('Projects') is pressed
    const unsubscribe = navigation.getParent().addListener('tabPress', (e) => {
      console.log('tabPress');
      // scrollRef.current.scrollTo({ x: 0, y: 0, animated: true });
      getCustomers();
    });
    return unsubscribe;
  }, [navigation]);

  React.useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      getCustomers()
    });
    return unsubscribe;
  }, [navigation]);

  // React.useEffect(() => {
  //   if (Platform.OS === 'web') {
  //     Dimensions.addEventListener('change', onChangeDimensions);
  //     return () => {
  //       Dimensions.removeEventListener('change', onChangeDimensions);
  //     }
  //   }
  // }, []);

  // const onChangeDimensions = ({ window, screen }) => {
  //   console.log('onChangeDimensions');
  //   setInviteImgStyle(inviteImgStyleWeb(window.width));
  // };

  // const inviteImgStyleWeb = (windowWidth) => {
  //   if (Platform.OS === 'web') {
  //     const ratio = 732 / 1000;
  //     let width = (windowWidth >= 768 ? 748 : (windowWidth - 20));
  //     console.log('logoStyle: ', width, width * ratio)
  //     return {
  //       width: width,
  //       height: width * ratio,
  //     }
  //   }
  //   return {};
  // }

  const getCustomers = async () => {
    setLoading(true);
    // setRefreshingNear(true);
    rtApi.get('users')
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('getCustomers', data);
      setLoading(false);
      processCustomers(data.users);
      // testing
      // const testUsers = [...data.users];
      // testUsers[1] = {...data.users[0]};
      // testUsers[1].id = 19999;
      // processCustomers(testUsers);
    })
    .catch((error) => {
      setLoading(false);
      console.log(error);
    });
  }

  const processCustomers = (c) => {
    // const activeStages = ['Active', 'In-Progress'];
    // let active = c.filter(c => { return activeStages.includes(c.stage); });
    let active = c.filter(c => { return c.stage !== 'Completed'; });
    let past = c.filter(c => { return c.stage === 'Completed'; });
    let customers = [];
    if (active.length > 0) {
      customers.push({
        title: 'Current Customers',
        data: active,
      });
    }
    if (past.length > 0) {
      customers.push({
        title: 'Past Customers',
        data: past,
      });
    }
    setCustomers(customers);
    console.log('processCustomers: ', customers);
  }
  
  // const invite = () => {
  //   console.log('invite this bitch');
  //   console.log(`/customer/0/invite`);
  //   // navigation.navigate('InviteScreen', {
  //   //   inviteType: 'Customers',
  //   // })
  //   // linkTo(`/customer/${0}/invite?inviteType=Customers`);
  //   linkTo(`/customer/0/invite?customerId=0`);
  // }

  // const inviteHeader = () => {
  //   return (
  //     <TouchableOpacity style={styles.imgTextContainer} activeOpacity={0.6} onPress={invite}>
  //       <Image style={[CS.responsiveImage, styles.inviteImg, inviteImgStyle]} source={require('../../assets/img/invite_banner.png')} />
  //       <View style={styles.inviteTextContainer}>
  //         <Text style={[CS.smallTitle, CS.lightText, { marginBottom: 0 }]}>Invite a {user.isContractor ? 'Customer' : 'Contractor'} to Join Renovation Trust</Text>
  //       </View>
  //     </TouchableOpacity>
  //   )
  // }

  const selectCustomer = (customer) => {
    linkTo(`/customer/${customer.id}`);
  }

  return (
    <SafeAreaView style={CS.safe}>
      <BackgroundGradient />
      {Platform.OS === 'web' ?
        <Loader animating={loading} />
      : null}
      <View style={[CS.innerContainer, { marginBottom: 10 }]}>
        <Text style={[CS.largeText, CS.lightText, CS.centerText, CS.boldText, { marginVertical: 10 }]}>Customers</Text>
        <SectionList
          sections={customers}
          keyExtractor={item => item.id.toString()}
          renderSectionHeader={({ section: { title } }) => <Text style={[CS.smallTitle, CS.lightText]}>{title}</Text>}
          renderItem={({ item }) => <UserTile user={item} select={selectCustomer} />}
          // ItemSeparatorComponent={() => (<View style={{ 'height': 0 }} />)}
          refreshControl={<RefreshControl refreshing={loading} onRefresh={getCustomers} colors={[Colors.yellow]} tintColor={Colors.yellow} />}
          // ListHeaderComponent={inviteHeader}
          ListEmptyComponent={() => <Text style={[CS.smallText, CS.lightBlueText, CS.centerText, { marginTop: 20 }]}>{loading ? 'Loading' : `Once a customer has accepted a Project with you, their information will be shown on this ${Platform.OS === 'web' ? 'page' : 'screen'}`}</Text>}
        />

      </View>
    </SafeAreaView>
  );

}

const styles = StyleSheet.create({
  inviteImg: {
    marginBottom: 10,
    aspectRatio: 1000 / 732,
  },
  inviteTextContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    padding: 20,
  },
});

export default Customers;
